import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';

// Register Swiper
register();

const initSliders = () => {
  const swiperContainer = document.querySelector<HTMLElement>(
    '.event-related.swiper',
  );

  if (swiperContainer) {
    const nextButton = swiperContainer.querySelector<HTMLElement>(
      '.custom-button-next',
    );
    const prevButton = swiperContainer.querySelector<HTMLElement>(
      '.custom-button-prev',
    );

    new Swiper(swiperContainer, {
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      slidesPerView: 1,
      spaceBetween: 24,
      breakpoints: {
        1024: {
          spaceBetween: 24,
          slidesPerView: 2,
          enabled: true,
        },
        1440: {
          spaceBetween: 36,
          slidesPerView: 3,
          enabled: false,
        },
      },
    });
  }
};

initSliders();
